import api from './api';
import { BusinessAreaSummary } from '../types';

/**
 * Auswertung je Vorhaben: was es eingebracht und was es gekostet hat.
 *
 * Eigener Dienst statt eines Zweigs im `invoiceService`, weil die Zahlen aus beiden Ecken kommen
 * — Ausgangsrechnungen und Kontoumsätze — und keiner von beiden gehören.
 */
const businessAreaService = {
  /** Die bereits vergebenen Bereiche — Auswahlvorlage, damit keine Schreibvarianten entstehen. */
  list: async (): Promise<string[]> => {
    const response = await api.get('/business-areas');
    return response.data;
  },

  /** Erlös, Kosten und Ergebnis je Bereich; ohne Jahr das jüngste, in dem etwas steht. */
  summary: async (year?: number): Promise<BusinessAreaSummary> => {
    const response = await api.get('/business-areas/summary', { params: year ? { year } : undefined });
    return response.data;
  },
};

export default businessAreaService;
